// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
// import 'babel-polyfill'
import Vue from 'vue';
import App from './App';
import router from './router';
import store from "./store";
import "./plugins/utils";
import "./plugins/table";
import './assets/style/css/ellipsis.css'
import ElementUI  from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
// import 'babel-polyfill';
import Http from "./utils/request";
import 'ant-design-vue/dist/antd.less'
import '@icon-park/vue/styles/index.css';
import '../public/color.less'
import { install } from '@icon-park/vue/es/all'
install(Vue, 'svg');
const Base64 = require('js-base64').Base64
// main.js
import lodash, { mixin } from 'lodash'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
NProgress.configure({ showSpinner: false }) // 去除圆形加载状态图标
import { selectDictLabel} from "@/utils/index";
import CryptoJS from 'crypto-js'
import moment from "moment";

import axios from 'axios'

import './plugins/directive'


import PrevImage from "@/components/prevImage.vue"
import renderExtraTimeFooter from "@/components/renderExtraTimeFooter.vue";
import renderCollapseHeader from "@/components/renderCollapseHeader.vue";
// const moment = require('moment');
import "moment/locale/zh-cn"
moment.locale("zh-cn");
// import './plugins/simba.mixin'
import Print from 'vue-print-nb'



// import "./plugins/antDesign";
import checkPermission, {checkPermissionName,checkPermissionBtn}  from './plugins/checkpermission'



import {Download} from "./common/download"


import {
  Spin,
  Statistic,
  Modal,
  Row,
  Col,
  Form,
  Tree,
  ConfigProvider,
  TreeSelect,
  message,
  Layout,
  Input,
  InputNumber,
  Select,
  Carousel,
  Table,
  Dropdown,
  Menu,
  Card,
  FormModel,
  Pagination,
  Icon,
  Button,
  DatePicker,
  Checkbox,
  Radio,
  Notification,
  Upload,
  // UploadOutlined,
  Steps,
  List,
  Cascader,
  Divider,
  Breadcrumb,
  Tabs,
  Badge,
  Popover,
  Switch,
  PageHeader, Space, Popconfirm,
  Collapse, Skeleton,
} from "ant-design-vue";

import RangePicker from "ant-design-vue/lib/date-picker/RangePicker";

Vue.use(Row)
  // .use(Upload.UploadOutlined)
  .use(Spin)
  .use(Statistic)
  .use(Statistic.Countdown)
  .use(Col)
  .use(Carousel)
  .use(ConfigProvider)
  .use(Card)
  .use(Form)
  .use(Layout)
  .use(Tree)
  .use(TreeSelect)
  .use(Input)
  .use(InputNumber)
  .use(Select)
  .use(Form)
  .use(FormModel)
  .use(Table)
  .use(Badge)
  .use(Dropdown)
  .use(Menu)
  .use(Pagination)
  .use(Icon)
  .use(Button)
  .use(Modal)
  .use(DatePicker)
  .use(Checkbox)
  .use(Radio)
  .use(Upload)
  .use(Steps)
  .use(List)
  .use(Divider)
  .use(Cascader)
  .use(RangePicker)
  .use(Breadcrumb)
  .use(Space)
  .use(Popconfirm)
  .use(Tabs)
  .use(PageHeader)
  .use(Collapse)
  .use(Popover)
  .use(Switch)
  .use(Skeleton);
Vue.use(Http);
Vue.use(Print);

Vue.use(ElementUI)
Vue.config.productionTip = false
Vue.prototype.$confirm = Modal.confirm;
Vue.prototype.$error = Modal.error;

Vue.prototype.$moment = moment;
Vue.prototype.$axios = axios
Vue.prototype.$message = message;

Vue.prototype.$Download = Download;

Vue.prototype.checkPermission = checkPermission


Vue.prototype.checkPermissionName = checkPermissionName;

Vue.prototype.checkPermissionBtn = checkPermissionBtn;

Vue.prototype.selectDictLabels = selectDictLabel
Vue.prototype.$lodash = lodash
//判断属性
Vue.prototype.hasProperty = function(obj,key){
     return key in obj;
 }

let ivDes3="3DESIV00";
Vue.prototype.des3Encrypt = function (key, text) {
  const keyHex = CryptoJS.enc.Utf8.parse(key)
  const ivHex = CryptoJS.enc.Utf8.parse(ivDes3)
  const encrypted = CryptoJS.TripleDES.encrypt(text, keyHex, {
    iv: ivHex,
    // 缺省为CBC
    mode: CryptoJS.mode.CBC
    // 缺省为Pkcs7
    // padding: CryptoJS.pad.Pkcs7
  })
  return CryptoJS.enc.Hex.stringify(encrypted.ciphertext)
}
Vue.prototype.des3Decrypt = function (key, text) {
  const keyHex = CryptoJS.enc.Utf8.parse(key)
  const ivHex = CryptoJS.enc.Utf8.parse(ivDes3)

  const decrypted = CryptoJS.TripleDES.decrypt({
    cipherText: CryptoJS.enc.Hex.parse(text)
  }, keyHex, {
    iv: ivHex,
    // 缺省为CBC
    mode: CryptoJS.mode.CBC
    // 缺省为Pkcs7
    // padding: CryptoJS.pad.Pkcs7
  })
  return decrypted.toString(CryptoJS.enc.Utf8)
}

Vue.component("PrevImage",PrevImage);

Vue.component("renderExtraTimeFooter",renderExtraTimeFooter);

Vue.component("renderCollapseHeader",renderCollapseHeader);




router.beforeEach((to, from , next) => {
  // 每次切换页面时，调用进度条
  NProgress.start();
  // 这个一定要加，没有next()页面不会跳转的。这部分还不清楚的去翻一下官网就明白了
  next();
});
router.afterEach((to, from) => {
  // store.dispatch("setRouterTags",to)
  NProgress.done()
})
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  Base64,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js